import React from 'react';
import { Icon } from './Icon.js';
export const IconMobilePen = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M11 6L13 6", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M17 22L22.5 16.5L19.5 13.5L14 19V22H17Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M20 9.46191L18 11.4619V3H6V21H11V23H4V1H20V9.46191Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconMobilePen.js.map